<template>
  <div class="oauth-wrapper">
    <img
      src="@/assets/images/doodles/oauth-error.jpg"
      class="asset"
      alt="Installation failed"
    />
    <h3>{{ title }}</h3>
    <p>{{ message }}</p>
    <a
      href="mailto:support@getmacha.com?subject=Zendesk%20oAuth%20Failed&body=Hi%20Team%2C%0A%0AI%20need%20help%20with%20my%20app%20installation%20%E2%80%94%20the%20Zendesk%20OAuth%20process%20failed.%20Could%20you%20please%20assist%3F%0A%0AThanks%2C%0A[Your%20Name]"
      target="_blank"
      class="btn btn-small btn-primary"
      >Contact Support</a
    >

    <img src="@/assets/images/logo.png" class="logo" alt="Macha Logo" />
  </div>
</template>
  
<script>
export default {
  name: "OauthSuccess",
  data() {
    return {
      title: "Installation Failed",
      message: "Something went wrong while trying to authorize your Zendesk",
    };
  },
  components: {},
  methods: {},
};
</script>
  
<style scoped lang="scss">
.oauth-wrapper {
  text-align: center;
  margin-top: 3rem;
}

.asset {
  width: 10rem;
  display: block;
  margin: 1rem auto 2rem;
}

.btn {
  display: inline-block;
  margin: 1.5rem auto 0;
}

.logo {
  position: absolute;
  display: block;
  width: 5rem;
  margin: auto;
  bottom: 3rem;
  left: 0;
  right: 0;
}
</style>